import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import DeliveryList from './DeliveryList'
import { useSelector } from 'react-redux'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'

const DeliveryTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('manage-delivery')
  const { pageAccess } = useSelector((state) => state.user)

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }
  return checkPageAccess(
    pageAccess,
    allPages?.manageDelivery,
    allCrudNames?.read
  ) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.manageDelivery,
              allCrudNames?.read
            ) && (
              <Link
                onClick={(e) => handleTabClick(e, "manage-delivery'")}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'manage-delivery' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Manage Delivery
                  <hr />
                </span>
              </Link>
            )}
          </div>
          {checkPageAccess(
            pageAccess,
            allPages?.manageDelivery,
            allCrudNames?.read
          ) && (
            <div className='tab-content p-3'>
              <div
                id='manage-delivery'
                className={`tab-pane fade ${
                  activeToggle === 'manage-delivery' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'manage-delivery' && <DeliveryList />}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default DeliveryTabbing
